import styled from 'styled-components/macro';

export const Track = styled.div.attrs({ className: 'dsc-theme-switcher' })`
  display: inline-flex;
  box-sizing: border-box;
  border-radius: var(--tab-radius);
  background-color: var(--colors-surface-strong, #e6ecf4);
`;

export const Option = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  padding: 0;
  cursor: pointer;
  border: 1px solid ${({ $selected }) => ($selected ? 'var(--colors-borders-outline-brand)' : 'transparent')};
  border-radius: var(--tab-radius);
  background-color: ${({ $selected }) => ($selected ? 'var(--colors-surface-secondary)' : 'transparent')};
  color: ${({ $selected }) => ($selected ? 'var(--colors-text-brand)' : 'var(--colors-text-normal)')};

  &:focus-visible {
    outline: 1px solid var(--colors-borders-outline-brand);
    outline-offset: 1px;
  }
`;
